import {
    GALLERY_FILTER_UPDATE_TERM,
    GALLERY_FILTER_UPDATE_CATEGORY,
    GALLERY_FILTER_PAGE_NEXT,
    GALLERY_FILTER_PAGE_PREV
} from '../actions/constants'

const defaultState = {
    term: undefined,
    category: undefined,
    page: 1,
    page_size: 10
};

export default (state = defaultState, action) => {
    switch (action.type){
        case GALLERY_FILTER_UPDATE_TERM:
            return {
                ...state,
                term: action.payload.term || undefined
            };
        case GALLERY_FILTER_UPDATE_CATEGORY:
            return {
                ...state,
                category: action.payload.category || undefined
            }
        case GALLERY_FILTER_PAGE_NEXT:
            return {
                ...state,
                page: state.page + 1
            }
        case GALLERY_FILTER_PAGE_PREV:
            return {
                ...state,
                page: state.page - 1
            }
        default:
            return state;
    }
};